import React, { useState } from "react";

const CheckboxComponent = ({
  label,
  checked,
  residentPollQuestionOptionId,
  onChange,
  disabled
}: {
  label: string;
  checked: boolean;
  residentPollQuestionOptionId: number | null;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) => {
  const handleCheckboxChange = (e: any) => {
    onChange(e.target.checked);
  };

  return (
    <div className="my-4">
      <input
        type="checkbox"
        id={`checkbox_${residentPollQuestionOptionId}`}
        checked={checked}
        onChange={handleCheckboxChange}
        className={`mr-4 w-5 h-5 rounded focus:shadow-none focus:ring-offset-0 focus:ring-0 ${
          disabled && !checked ? "bg-gray-200" : ""
        }`}
        disabled={disabled}
      />
      <label htmlFor={`checkbox_${residentPollQuestionOptionId}`}>
        {label}
      </label>
    </div>
  );
};

export default CheckboxComponent;
